<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Pollen Processing 2"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>Pollen QR Code</td>
                        <td>{{ detailInfo.pollen.qrCode.code }}</td>
                    </tr>
                    <tr>
                        <td>Pollen Serial No</td>
                        <td>{{ detailInfo.pollen.serialNo }}</td>
                    </tr>
                    <tr>
                        <td>Pollen Palm</td>
                        <td>
                            <mpob-palm-format :cell="(detailInfo.pollen||{}).palm" /> 
                        </td>
                    </tr>
                    <tr>
                        <td>Dry Weight (g)</td>
                        <td>{{ detailInfo.dryWeight || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Moisture Content (%)</td>
                        <td>{{ moistureContent || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Viability Percentage (%)</td>
                        <td>{{ detailInfo.viabilityPercentage || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Stocked Date</td>
                        <td>{{ detailInfo.processedDate || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Number of Bottle(s)</td>
                        <td>{{ detailInfo.numberOfBottle || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Image</td>
                        <td>
                            <image-holder :images="detailInfo.recordingImages" />
                        </td>
                    </tr>
                    <tr>
                        <td>Remarks</td>
                        <td>{{ detailInfo.remarks || "-" }}</td>
                    </tr>
                </table>
            </div>
            
            <p class="detail-title detail-title-pd">Pollen Bottle</p>
            <pollen-processing-2-pollen-bottle-simple-table :pollen-bottle-list="detailInfo.pollenBottles" />

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { pollenProcessing2Get } from "@/api/pollen_processing_2";
import MPOBPalmFormat from "@/components/Progeny/MPOBPalmFormat";
import ImageHolder from "@/components/SidebarDetail/ImageHolder";
import PollenProcessing2PollenBottleSimpleTable from "@/components/Pollen/PollenProcessing2PollenBottleSimpleTable";

export default {
    components: {
        "detail-header": DetailHeader,
        "mpob-palm-format": MPOBPalmFormat,
        "image-holder": ImageHolder,
        "pollen-processing-2-pollen-bottle-simple-table": PollenProcessing2PollenBottleSimpleTable,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,
            mc: null
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo?.pollen?.qrCode?.code || "-";
        },
        moistureContent() {
            return this.detailInfo?.moistureContent?.toFixed(2);
        }
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await pollenProcessing2Get({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/PollenProcessing2Sidebar.vue